<script>
// https://github.com/glennflanagan/vue-collapsible/blob/master/src/components/Collapsible.vue
export default {
  name: 'Collapsible',
  data() {
    return {
      open: this.isOpen,
      height: this.isOpen ? 'auto' : '0px',
      closeOnNextTick: false,
      transitioning: false
    };
  },
  props: {
    openLabel: {
      type: String,
      default: 'Close me'
    },
    closedLabel: {
      type: String,
      default: 'Open me'
    },
    transitionDuration: {
      type: String,
      default: '300ms'
    },
    transitionTimingFunction: {
      type: String,
      default: 'ease'
    },
    transitionDelay: {
      type: String,
      default: '0s'
    },
    isOpen: {
      default: false,
      type: Boolean
    },
    onCollapse: {
      default: () => {},
      type: Function
    }
  },
  methods: {
    handleClick() {
      this.onCollapse(!this.isOpen);
      // this.open = !this.open;
      this.$emit('toggle', !this.isOpen);
    },
    handleEnd() {
      if (this.height !== '0px') {
        this.height = 'auto';
      }
      this.transitioning = false;
    }
  },
  watch: {
    open(newVal, oldVal) {
      this.transitioning = true;
      this.height = this.$refs.inner.scrollHeight + 'px';
      if (oldVal === true) {
        this.closeOnNextTick = true;
      }
    },
    isOpen(newVal) {
      this.open = newVal;
    }
  },
  updated() {
    this.$nextTick(() => {
      window.setTimeout(() => {
        if (this.closeOnNextTick) {
          this.height = '0px';
          this.closeOnNextTick = false;
        }
      });
    });
  }
};
</script>

<template>
  <div class="app-collapsible" :class="{ open }">
    <div class="header" @click.prevent="handleClick">
      <div class="container">
        <h3 class="title">
          <slot name="title" />
        </h3>
        <div class="description">
          <slot name="description" />
        </div>
      </div>

      <button
        type="button"
        class="trigger-button"
        :class="{
          'collapsible-trigger': true,
          'collapsible-trigger-open': !transitioning && open,
          'collapsible-trigger-closed': !transitioning && !open,
          'collapsible-trigger-transitioning': transitioning
        }"
      >
        <img src="@/assets/icons/arrow.svg" :class="{ open }" />
      </button>
    </div>

    <div
      :class="{
        'collapsible-content': true,
        'Collapsible__content--open': !transitioning && open,
        'Collapsible__content--closed': !transitioning && !open,
        'Collapsible__content--transitioning': transitioning
      }"
      :style="{
        height,
        transitionProperty: 'height',
        transitionDuration,
        transitionTimingFunction,
        transitionDelay
      }"
      @transitionend="handleEnd"
    >
      <div class="collapsible-content-inner" ref="inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$section-padding: 30px;

.app-collapsible {
  background: #fff;
  cursor: pointer;
  border: 1px solid #eff2fb;
  border-radius: 8px;

  .header {
    box-shadow: 0px 5px 20px #0018bc05;
  }

  .collapsible-content {
    overflow: hidden;
  }

  .collapsible-content-inner {
    padding: $section-padding;
    height: auto;
  }

  .collapsible-trigger {
    display: block;
    cursor: pointer;
  }

  .header {
    padding: 23px 30px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .container {
      .title {
        color: var(--primary-color);
        font-size: 16px;
        font-weight: 800;
      }

      .description {
        color: var(--purple-light-3);
        font-size: 14px;
        line-height: 19px;
      }
    }

    .trigger-button {
      transform: rotate(0deg);
      background: 0;
      border: 0;

      img {
        transition: transform 0.3s ease-in-out; // as transition duration length
        &.open {
          transform: rotate(90deg);
        }
      }

      &:focus {
        outline: 0;
      }
    }
  }
}
</style>
